/**
 * Represents the supported button variations.
 */
class ButtonVariant {
  /**
   * Indicates a primary button.
   */
  static primary = 'primary';

  /**
   * Indicates a secondary button.
   */
  static secondary = 'secondary';
}

Object.freeze(ButtonVariant);

export default ButtonVariant;
